import StorageService from './StorageService';

// eslint-disable-next-line import/prefer-default-export
export default { ...StorageService };
